import { GondelComponent } from '@gondel/core';

/**
 * Common interface for input-like components that need to be validated.
 */

export class ValidatableInputData {
	// holds some additional value if needed
	public additionalValue?: any;
	public constructor(public name: string, public value: string | boolean | number | any[] | null) {}
}

export interface IValidatableInputComponent extends GondelComponent {
	getData(): ValidatableInputData;
	_isValid(): boolean;
	_showValidationErrorsByBe(data: any): void;
}
